import type { PropsWithChildren } from "react";
import { ROUTES } from "~components/routeDefinitions.ts";
import { useBusinessConfig } from "~contexts/BusinessConfigContext/BusinessConfigContext.tsx";
import { RedirectToMainTenant } from "../RedirectToMainTenant/RedirectToMainTenant.tsx";

export function RequireValidTenantNumber({ children }: PropsWithChildren) {
  const { tenantNumber } = ROUTES.dashboard.useParams();
  const { tenants } = useBusinessConfig();

  const tenantNumberValid = tenants.some(
    (t) => `${t.tenant_number}` === tenantNumber,
  );

  if (tenantNumberValid) {
    return children;
  }

  return <RedirectToMainTenant />;
}
